export function cleanPathname(url: string): string {
    if (!url) return ''
    let validPathname = url.trim()
    validPathname = `/${validPathname.replace(/\/+/g, '/').replace(/\/$/, '').replace(/^\//, '')}/`
    return validPathname
}

export function cleanUrl(url: string): string {
    if (!url) return ''
    let validUrl = url.trim()
    validUrl = `${validUrl.replace(/([^:])\/+/g, '$1/').replace(/\/$/, '')}/`
    return validUrl
}
